export function getMenlo79GlobalConfig(configName: string) {
  const configValue = (
    document.querySelector(`meta[name="${configName}"]`) as HTMLMetaElement
  )?.content;

  return configValue || '';
}
